import React from 'react';
import Router from './Router';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from '../redux';
import { fetchSprite } from '../api';
import ConfirmPopup from './Confirm';

const SPRITE_ID = 'svg-sprite';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.fetchSprite();
  }

  componentWillUnmount() {
    this.cleanupSprite();
  }

  fetchSprite = async () => {
    const text = await fetchSprite();
    const div = document.createElement('div');
    div.id = SPRITE_ID;
    div.style.display = 'none';
    div.innerHTML = text;
    document.body.appendChild(div);
  };

  cleanupSprite = () => {
    const sprite = document.querySelector(`#${SPRITE_ID}`);
    if (sprite) {
      document.body.removeChild(sprite);
    }
  };

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <>
            <Router />
            <ConfirmPopup />
          </>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
